<template>
  <ul class="locale-switcher">
    <li v-for="locale in locales" :key="`locale-${locale.value}`">
      <a
        class="inverted"
        href="#"
        @click.prevent="preferences.setLocale(locale.value)"
      >
        <span class="locale-label-long">{{ locale.label }}</span>
        <span class="locale-label-short">{{ locale.value }}</span>
      </a>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { supportedLocales } from '@/i18n'
import { SupportedLocaleList } from '@/i18n/types'
import { usePreferencesStore } from '@/store/preferences'

const preferences = usePreferencesStore()

const locales = computed<SupportedLocaleList>(
  (): SupportedLocaleList => supportedLocales,
)
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.locale-switcher {
  display: flex;
  flex-flow: column nowrap;
  padding: 1em 0 0 2em;
  margin: 0;
  border-top: $border-width solid $color-text-link;
  list-style: none;

  @media screen and (min-width: $break-point-laptop) {
    flex-flow: row nowrap;
    padding: 0 0 0 1em;
    gap: 1.25em;
    border-left: $border-width solid $color-text-link;
    border-top: none;
  }

  li > a {
    display: block;
    padding: 1em 0;

    @media screen and (min-width: $break-point-laptop) {
      padding: 0.5em 0;
    }

    .locale-label-long {
      display: inline;
      text-transform: capitalize;

      @media screen and (min-width: $break-point-laptop) {
        display: none;
      }
    }

    .locale-label-short {
      display: none;
      text-transform: uppercase;

      @media screen and (min-width: $break-point-laptop) {
        display: inline;
      }
    }
  }
}
</style>
